import _ from 'underscore'

/**
 *
 * SMS Store
 *
 * @see ApiSmsController.php
 *
 */

const state = {
    loading: false,
    messages: [],
    pageInfo: null,
    offset: 1,
    total: null,
    canLoadMore: true,
    stats: false,
    selectedMessage: [],

    // Whether to search for assigned or un-assigned messages
    searchAssigned: false,
    searchTerm: ''
}

const getters = {
    loading: (state) => state.loading,
    messages: (state) => state.messages,
    pageInfo: (state) => state.pageInfo,
    offset: (state) => state.offset,
    total: (state) => state.total, // total from server, NOT total retrieved
    totalLoaded: (state) => state.messages.length,
    canLoadMore: (state) => state.canLoadMore,
    stats: (state) => state.stats,
    selectedMessage: (state) => state.selectedMessage,
    searchAssigned: (state) => state.searchAssigned,

    dateGroupedMessages: (state) => {
        let messages = state.messages
        let searchTerm = state.searchTerm

        // Filter messages by search term
        messages = messages.filter((e, i) => {
            if (searchTerm.length > 0) {
                // Search these variables
                const search = [
                    e.message, e.from, e.to, e.id,
                    e.date_sent, Moment(e.date_sent).format('DD/MM/YYYY')
                ]
                //
                return search.join(' ').search(new RegExp(searchTerm, 'ig')) > -1
            }
            return true
        })

        // Group messages and return
        return _.groupBy(messages, (e) => {
            return Moment(e.date_sent).format('DD/MM/YYYY')
        })
    },

    conversations: (state) => {
        return []
    }
}

// Synchronous Only
const mutations = {
    loading(state, payload) {
        state.loading = payload
    },
    messages(state, payload) {
        // Format messages
        payload.map((e, i) => {
            return e
        })

        state.messages = payload
    },
    pageInfo(state, payload) { state.pageInfo = payload },
    selectMessage(state, payload) {
        const { message, multiple = false } = payload

        // Clear all selections if payload is false
        if (payload === false) return state.selectedMessage = []

        // Multi Select
        const isMessageSelected = state.selectedMessage.find((e) => e === message)
        //

        // If not selecting multiple, empty the array first
        if (multiple === false) state.selectedMessage = []

        // Deselect message if already selected
        if (isMessageSelected) state.selectedMessage = state.selectedMessage.filter((e) => e !== message)
        // else add the message to the array
        else state.selectedMessage.push(message)

        // SINGLE SELECT
        // If already selected (or if payload is false) deselect the message
        // if (isMessageSelected || payload === false) state.selectedMessage = []
        // else state.selectedMessage.push(message)
    },
    markAsRead(state, payload) {
        const selectedMessageIds = _.pluck(state.selectedMessage, 'id')
        // return

        state.messages.map((e, i) => {
            if (selectedMessageIds.includes(e.id)) e.is_read = payload.is_read
            return e
        })
    },

    assignMessage(state, payload) { },
    deleteMessage(state, payload) { },
    searchAssigned(state, payload) { state.searchAssigned = payload },
    offset(state, payload) { state.offset = payload },
    total(state, payload) { state.total = payload },
    canLoadMore(state, payload) { state.canLoadMore = payload },
    stats(state, payload) { state.stats = payload },
    searchTerm(state, payload) { state.searchTerm = payload }
}

const actions = {
    async getMessages(context, payload = {}) {
        context.commit('loading', true)

        if (payload.next === true) context.commit('offset', context.state.offset + 1)
        else if (payload.prev === true) context.commit('offset', context.state.offset - 1)
        else if (payload.offset) context.commit('offset', payload.offset)

        const searchAssigned = context.state.searchAssigned
        const offset = context.state.offset

        Ambition.Request.call({
            url: `/api/applications/sms/search`,
            method: 'get',
            params: {
                assigned: searchAssigned,
                offset,
                page: offset
            }
        }).then((e) => {


            const { total, stats } = e.data
            const pageInfo = e.data.messages
            const messages = pageInfo.data

            // Simple pagination
            if (Array.isArray(messages) && messages.length > 0) {
                context.commit('messages', messages)
            }

            context.commit('total', total)
            context.commit('stats', stats)
            context.commit('pageInfo', pageInfo)
        }).catch((err) => {
            console.error('SmsQueue', err)
        })

        // Perceived delay to show indicator
        await new Promise(resolve => setTimeout(resolve, 500))
        context.commit('loading', false)
    },

    async selectMessage(context, payload) {
        context.commit('selectMessage', payload)
    },

    async markAsRead(context, payload) {
        const data = {
            messages: context.state.selectedMessage,
            is_read: typeof payload.is_read === 'number' ? payload.is_read : 1
        }

        context.commit('markAsRead', data)

        Ambition.Request.call({
            url: `/api/applications/sms/read`,
            method: 'post',
            data
        }).then((e) => {

        }).catch((err) => {
            throw Error(err)
        })
    },

    async assignMessage(context, payload) {
        context.commit('assignMessage', payload)

        const token = Ambition.getGlobal('tenant.token')
        const headers = { Authorization: `Bearer ${token}` }

        const messages = context.state.selectedMessage

        context.commit('loading', true)

        try {
            const request = await axios.post(`/api/applications/sms/assign`, {
                assignTo: payload,
                messages
            }, { headers })
            //

            // Deselect message
            context.commit('selectMessage', false)

        } catch (error) {
            console.error('store/modules/sms', error)
        }

        // Perceived delay to show indicator
        context.commit('loading', false)
    },

    async deleteMessage(context, payload) {
        const token = Ambition.getGlobal('tenant.token')
        const headers = { Authorization: `Bearer ${token}` }

        context.commit('loading', true)

        try {
            const request = await axios.post(`/api/applications/sms/delete`, {
                messages: context.state.selectedMessage
            }, { headers })

            // Deselect message
            context.commit('selectMessage', false)
        } catch (error) {
            console.error('store/modules/sms', error)
        }
        context.commit('loading', false)
    },

    async searchAssigned(context, payload) {
        if (typeof payload !== 'boolean') throw new Error('Payload must be boolean for searchAssigned() method')
        context.commit('searchAssigned', payload)

        // Empty messages when changing search view
        context.commit('messages', [])
    },

    async setSearchTerm(context, searchTerm) {
        context.commit('searchTerm', searchTerm)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
